const setGroup = (group) => {
    return {
        type: 'GET_DATA_GROUP',
        data: group
    }
}

module.exports = {
    setGroup
}